import type { PressEvent } from '@react-types/shared';
import { useState } from 'react';
import { USER_GUIDE } from 'utils/constants/Preview';

import {
  ButtonProps,
  Link,
  reactIcons,
  Typography,
} from '@project44/manifest-ds';
import { Banner } from '@project44/shared-components';
import { useTranslation } from '@project44/translations-utils';
import { getP44Env } from '@project44/ui-utils';

import GetInTouchModal from '../GetInTouchModal/GetInTouchModal';

function BannerMovementPreview() {
  const { t, t__react } = useTranslation();
  const [getInTouchModalOpen, setGetInTouchModalOpen] = useState(false);
  const vocLinkText = (
    <Link href={getP44Env().VOC_BASE_URL} style={{ color: 'white' }}>
      {t('previewBanner.vocLinkText')}
    </Link>
  );
  const subTitle = t__react('previewBanner.subTitle', { vocLinkText });
  const sub: JSX.Element = <Typography>{subTitle}</Typography>;
  const onGetInTouch: (event: PressEvent) => void = () =>
    setGetInTouchModalOpen(true);

  const bannerProps = {
    title: t('previewBanner.title'),
    subTitle: sub,
    buttonText: t('previewBanner.buttonText'),
    tertiaryButtonText: t('previewBanner.userGuideButtonText'),
    css: {
      backgroundColor: '$palette-grey-900',
      textAlign: 'center',
      justifyContent: 'center',
      flex: '1 1 auto',
      padding: '12px $large',
    },
  };

  const buttonProps: ButtonProps = {
    size: 'small',
    onPress: onGetInTouch,
    css: {
      flex: '0 0 auto',
      marginLeft: '80px',
      '@media (max-width: 968px)': {
        alignItems: 'flex-start',
        marginLeft: '40px',
      },
    },
  };

  const tertiaryButtonProps: ButtonProps = {
    size: 'small',
    onPress: () => window.open(USER_GUIDE),
    endIcon: <reactIcons.OpenInNewTab size="small" />,
    css: {
      color: '#FFFFFF',
      flex: '0 0 auto',
      background: '$palette-grey-900',
    },
  };
  return (
    <div style={{ display: 'flex' }}>
      {getInTouchModalOpen && (
        <GetInTouchModal
          onClose={() => setGetInTouchModalOpen(false)}
        ></GetInTouchModal>
      )}
      <Banner
        {...bannerProps}
        titleCSS={{
          color: 'var(--text-contrast, #FFF)',
          '@media (max-width: 1024px)': {
            alignItems: 'flex-start',
            justifyContent: 'left',
            textAlign: 'left',
          },
        }}
        buttonProps={buttonProps}
        tertiaryButtonProps={tertiaryButtonProps}
      />
    </div>
  );
}

export default BannerMovementPreview;
